import React from "react";
import "./CookieInfo.scss";

class CookieInfo extends React.Component {
  render() {
    return (
      <div className="cookieInfo">
        Informácia o súlade so Zákonom 452/2021: Portál pri svojej funkčnosti
        nepoužíva personalizované súbory (cookies).
      </div>
    );
  }
}

export default CookieInfo;
